var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkOverlaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2316_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1092 15.6969L12.3642 15.6762H11.257V17.3192L11.2622 19.0381L15.5427 19.0568H17.1092V15.6969Z",
    fill: "#FDD167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5172 18.9139L11.315 17.1482L3.98143 16.8963C2.92054 16.8963 0.390818 16.7876 0.170929 15.7921L0.409707 19.0568H0.420818C0.48654 18.8233 0.691818 19.3759 0.946485 19.3759C1.20115 19.3759 1.40665 18.8233 1.47237 19.0568H10.7882C10.7755 19.0102 11.5172 18.9646 11.5172 18.9139Z",
    fill: "#573424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5965 16.9802H17.3062V18.9139C17.3062 18.9646 17.5907 19.0102 17.578 19.0568H26.4946C26.5637 18.8287 26.7673 19.4922 27.0181 19.4922C27.269 19.4922 27.4726 18.8287 27.5417 19.0568H27.5484L27.7926 15.5733C27.6621 16.6753 26.0076 16.6638 25.5965 16.9802Z",
    fill: "#573424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8189 15.0993V15.1984L27.8259 15.0993H27.8189Z",
    fill: "#6A462F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.67131 15.9519C0.67131 15.9519 0.548199 17.0124 2.76014 16.9802C4.41737 16.956 11.011 16.9802 11.011 16.9802L11.5798 15.9256L16.8015 15.8815L17.578 16.8238C17.578 16.8238 24.2283 17.1077 25.5965 16.9802C27.3959 16.8125 27.2631 14.8187 27.2631 14.758V6.56717H0.67131V15.9519Z",
    fill: "#855038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6068 18.6407H10.7595H0.962689L0.963023 18.6522C1.26208 18.6613 0.671356 19.3831 0.671356 19.6844L0.946523 28.1946H27.0181V19.2154C27.0181 18.9413 26.6642 18.7242 26.9251 18.6785L26.926 18.6407H17.6068Z",
    fill: "#855038"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 1.33334,
    y: 6.83333,
    width: 25.3333,
    height: 1.33333,
    fill: "#D3AB5E"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 1.33334,
    y: 16.1667,
    width: 25.3333,
    height: 0.666667,
    fill: "#D3AB5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55557 6.05556V3.83334C9.55557 2.91287 10.3018 2.16667 11.2222 2.16667H16.7778C17.6983 2.16667 18.4445 2.91286 18.4445 3.83334V6.05556",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0181 19.2154V28.1946H0.946472V19.2045",
    stroke: "black",
    strokeWidth: 1.11111,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3062 16.9802H25.5965C26.517 16.9802 27.2632 16.234 27.2632 15.3135V6.56717H0.671356V15.3135C0.671356 16.234 1.41752 16.9802 2.33802 16.9802H11.0111",
    stroke: "black",
    strokeWidth: 1.11111,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0511 15.6762H11.315V18.9139H17.0511V15.6762Z",
    stroke: "black",
    strokeWidth: 1.11111,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2316_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.833328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOverlaps);
export default __webpack_public_path__ + "static/media/work-overlaps.80096c0c686ce4c42039af0dd1ae5240.svg";
export { ForwardRef as ReactComponent };